/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */
import type {
  AccessDeniedErrorResponse,
  AttachPropertyVendorRequest,
  BadRequestErrorResponse,
  GetApiPropertyVendorsList200,
  GetApiPropertyVendorsListParams,
  GetApiVendorPropertiesList200,
  GetApiVendorPropertiesListParams,
  NotFoundErrorResponse,
  PropertyVendorApiResource,
  UnauthorizedErrorResponse
} from '.././models';

import { customFetch } from '../../custom-fetch';

export type postApiPropertyVendorAttachResponse201 = {
  data: PropertyVendorApiResource
  status: 201
}

export type postApiPropertyVendorAttachResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type postApiPropertyVendorAttachResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type postApiPropertyVendorAttachResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type postApiPropertyVendorAttachResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type postApiPropertyVendorAttachResponseSuccess = (postApiPropertyVendorAttachResponse201) & {
  headers: Headers;
};
export type postApiPropertyVendorAttachResponseError = (postApiPropertyVendorAttachResponse400 | postApiPropertyVendorAttachResponse401 | postApiPropertyVendorAttachResponse403 | postApiPropertyVendorAttachResponse404) & {
  headers: Headers;
};

export type postApiPropertyVendorAttachResponse = (postApiPropertyVendorAttachResponseSuccess | postApiPropertyVendorAttachResponseError)

export const getPostApiPropertyVendorAttachUrl = (id: number,) => {


  

  return `/api/properties/${id}/vendors/attach`
}

export const postApiPropertyVendorAttach = async (id: number,
    attachPropertyVendorRequest: AttachPropertyVendorRequest, options?: RequestInit): Promise<postApiPropertyVendorAttachResponse> => {
  
  return customFetch<postApiPropertyVendorAttachResponse>(getPostApiPropertyVendorAttachUrl(id),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      attachPropertyVendorRequest,)
  }
);}


export type deleteApiPropertyVendorDeleteResponse204 = {
  data: void
  status: 204
}

export type deleteApiPropertyVendorDeleteResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type deleteApiPropertyVendorDeleteResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type deleteApiPropertyVendorDeleteResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type deleteApiPropertyVendorDeleteResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type deleteApiPropertyVendorDeleteResponseSuccess = (deleteApiPropertyVendorDeleteResponse204) & {
  headers: Headers;
};
export type deleteApiPropertyVendorDeleteResponseError = (deleteApiPropertyVendorDeleteResponse400 | deleteApiPropertyVendorDeleteResponse401 | deleteApiPropertyVendorDeleteResponse403 | deleteApiPropertyVendorDeleteResponse404) & {
  headers: Headers;
};

export type deleteApiPropertyVendorDeleteResponse = (deleteApiPropertyVendorDeleteResponseSuccess | deleteApiPropertyVendorDeleteResponseError)

export const getDeleteApiPropertyVendorDeleteUrl = (id: number,) => {


  

  return `/api/property-vendors/${id}`
}

export const deleteApiPropertyVendorDelete = async (id: number, options?: RequestInit): Promise<deleteApiPropertyVendorDeleteResponse> => {
  
  return customFetch<deleteApiPropertyVendorDeleteResponse>(getDeleteApiPropertyVendorDeleteUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}


export type getApiPropertyVendorsListResponse200 = {
  data: GetApiPropertyVendorsList200
  status: 200
}

export type getApiPropertyVendorsListResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiPropertyVendorsListResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type getApiPropertyVendorsListResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type getApiPropertyVendorsListResponseSuccess = (getApiPropertyVendorsListResponse200) & {
  headers: Headers;
};
export type getApiPropertyVendorsListResponseError = (getApiPropertyVendorsListResponse401 | getApiPropertyVendorsListResponse403 | getApiPropertyVendorsListResponse404) & {
  headers: Headers;
};

export type getApiPropertyVendorsListResponse = (getApiPropertyVendorsListResponseSuccess | getApiPropertyVendorsListResponseError)

export const getGetApiPropertyVendorsListUrl = (id: number,
    params?: GetApiPropertyVendorsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/properties/${id}/vendors?${stringifiedParams}` : `/api/properties/${id}/vendors`
}

export const getApiPropertyVendorsList = async (id: number,
    params?: GetApiPropertyVendorsListParams, options?: RequestInit): Promise<getApiPropertyVendorsListResponse> => {
  
  return customFetch<getApiPropertyVendorsListResponse>(getGetApiPropertyVendorsListUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type getApiVendorPropertiesListResponse200 = {
  data: GetApiVendorPropertiesList200
  status: 200
}

export type getApiVendorPropertiesListResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiVendorPropertiesListResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}
    
export type getApiVendorPropertiesListResponseSuccess = (getApiVendorPropertiesListResponse200) & {
  headers: Headers;
};
export type getApiVendorPropertiesListResponseError = (getApiVendorPropertiesListResponse401 | getApiVendorPropertiesListResponse403) & {
  headers: Headers;
};

export type getApiVendorPropertiesListResponse = (getApiVendorPropertiesListResponseSuccess | getApiVendorPropertiesListResponseError)

export const getGetApiVendorPropertiesListUrl = (params?: GetApiVendorPropertiesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/vendor/properties?${stringifiedParams}` : `/api/vendor/properties`
}

export const getApiVendorPropertiesList = async (params?: GetApiVendorPropertiesListParams, options?: RequestInit): Promise<getApiVendorPropertiesListResponse> => {
  
  return customFetch<getApiVendorPropertiesListResponse>(getGetApiVendorPropertiesListUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


